import React, { useEffect, useState } from 'react';
import { Button, FormGroup, Input } from 'reactstrap';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { sendFirebaseEvent } from '../../helper/mobile';
import { useDiet } from '../../hooks/useDiet';
import phone from './phone.svg';
import call from './call.svg';
import { differenceInDays } from 'date-fns';

const ASK_ARRAY = ['Weight management', 'Diabetes', 'PCOD', 'Hypertension', 'Thyroid', 'Other'];

const RequestCallBack = ({pageType}) => {

    const [isBtnDisabled, setIsBtnDisabled] = useState(false);
    const [isBtnDisabledBottom, setIsBtnDisabledBottom] = useState(true);
    const [open, setOpen] = useState(false);
    const [selectedOpt, setSelectedOpt] = useState([]);
    const [description, setDescription] = useState('');

    const { requestCall } = useDiet();

    const ImgBtn = () => (<><img src={phone} alt=""/> <span>Request a free consult</span></>);

    useEffect(() => {
        if(selectedOpt.includes('Other')) {
            setIsBtnDisabledBottom(description.length > 0 ? false : true)
        }else {
            setIsBtnDisabledBottom(selectedOpt.length > 0 ? false : true)
        }
    }, [selectedOpt, description]);

    useEffect(() => {
        const date = localStorage.getItem('requestCallTime');
        if(date){
            const dateDiff = differenceInDays(new Date(), new Date(date));
            if(dateDiff < 4)
                setIsBtnDisabled(true);
        }
    }, [])

    const onClickRequestCall = () => {
        sendFirebaseEvent('diet_plan_request_free_consult_btn', 'click_event', pageType);
        setOpen(true)
    }

    const onSubmitHandler = () => {
        const request = [...selectedOpt];
        if(selectedOpt.includes('Other'))
            request[selectedOpt.indexOf('Other')] = description;

        setOpen(false)
        sendFirebaseEvent('diet_plan_request_consult_submit_btn', 'click_event', pageType);
        requestCall(request);
        setTimeout(() => {
            setIsBtnDisabled(true);
        }, 2000);
    }

    const onBadgeClickHandler = value => {
        if(selectedOpt.includes(value))
            setSelectedOpt(selectedOpt.filter(obj => obj !== value));
        else
            setSelectedOpt([...selectedOpt, value])
    }

    return (
        <div className='text-center'>
            {
                pageType === 'main' &&
                <Button className="request-free-consult btn-ripple" onClick={onClickRequestCall} disabled={isBtnDisabled}>
                    {isBtnDisabled ? 'Request sent successfully' : <ImgBtn />}
                </Button>
            }
            {
                pageType === 'ai' &&
                <button onClick={onClickRequestCall} disabled={isBtnDisabled}><img src={call} alt=""/></button>
            }
            <BottomSheet open={open} onDismiss={() => setOpen(false)}>
                <div className='rcb-bottom-sheet'>
                    <h2 className='mb-3'>What would you like to ask the nutritionist?</h2>
                    <div>
                        {ASK_ARRAY.map(obj => <span key={obj} className={`rcb-badge ${selectedOpt.includes(obj) ? 'active' : ''}`} onClick={() => onBadgeClickHandler(obj)}>{obj}</span>)}
                    </div>
                    {
                        selectedOpt.includes('Other') &&
                        <FormGroup className='position-relative'>
                            <Input
                                type="textarea"
                                value={description}
                                onChange={e => setDescription(e.target.value)}
                                placeholder='Enter a description...'
                                maxLength="140"
                                rows={4}
                                className="rcb-description-input"
                            />
                            <span className='count'>{description.length}/140</span>
                        </FormGroup>
                    }
                    <Button className="risk-btn mt-2 mb-3" disabled={isBtnDisabledBottom} onClick={onSubmitHandler}>Submit and Proceed</Button>
                </div>
            </BottomSheet>
        </div>
    );
}

export default RequestCallBack;